
export default function IntegrationSucess(){
    return <h1>Success!</h1>
}